<template>
  <detail-layout-two-columns class="w-full" :toEdge="false">
    <template slot="LeftCol">
      <base-header class="normalizeHeader" icon="user" :content="header"/>
      <div class="form-wrapper">
        <el-form :model="form" :rules="rules" ref="ruleForm">

          <div class="hideHScroll">
            <div v-if="role === 3 && form.Cliente" class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('clients.entity_name')" :data="form.Cliente" />
              </div>
              <div v-if="form.Distribuidor" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('distributors.entity_name')" :data="form.Distribuidor" />
              </div>
            </div>

            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('verifactu.invoice_num_serie')" :data="form.NumSerieFactura" />
              </div>
              <div v-if="form.NumSerieAnterior" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('verifactu.previous_invoice_num_serie')" :data="form.NumSerieAnterior" />
              </div>
            </div>

            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div v-if="form.Empresa" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$tc('companies.entity_name', 1)" :data="form.Empresa" />
              </div>
              <div v-if="form.IdCifEmpresa && false" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('verifactu.company_cif')" :data="form.IdCifEmpresa" />
              </div>
            </div>

            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div v-if="form.CIF" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('companies.cif')" :data="form.CIF" />
              </div>
              <div v-if="form.SIF" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('verifactu.sif')" :data="form.SIF" />
              </div>
            </div>

            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div v-if="form.CuotaTotal" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('verifactu.total_quota')" :data="form.CuotaTotal" />
              </div>
              <div v-if="form.ImporteTotal" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('tipos.metadata.importe_total')" :data="form.ImporteTotal" />
              </div>
            </div>

            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div v-if="form.FechaAlta" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.fecha_alta')" :data="form.FechaAlta" />
              </div>
              <div v-if="form.FechaNotificacion" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('verifactu.date_notification')" :data="form.FechaNotificacion" />
              </div>
            </div>

            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div v-if="form.FechaExpedicion" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('verifactu.date_expedition')" :data="form.FechaExpedicion" />
              </div>
              <div v-if="form.FechaExpedicionAnterior" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('verifactu.previous_date_expedition')" :data="form.FechaExpedicionAnterior" />
              </div>
            </div>

            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div v-if="form.IdEstadoVerifactu" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('app.status')" :data="form.IdEstadoVerifactu" />
              </div>
              <div v-if="form.IdAccionVerifactu" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('verifactu.action_type')" :data="form.IdAccionVerifactu" />
              </div>
            </div>

            <div v-if="form.IdTipoFactura" class="lg:mb-4" >
              <base-ro-input :label="$t('verifactu.invoice_type.entity_name')" :data="form.IdTipoFactura" />
            </div>

            <div v-if="form.HuellaRegistro" class="lg:mb-4">
              <base-ro-input :label="$t('verifactu.register_print')" :data="form.HuellaRegistro" />
            </div>

            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div v-if="form.CSVZC" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('verifactu.csvzc')" :data="form.CSVZC" />
              </div>
              <div v-if="form.CSVAEAT" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('verifactu.csvaeat')" :data="form.CSVAEAT" />
              </div>
            </div>  

            <div v-if="form.URLQR" class="lg:mb-4" >
              <base-ro-input :label="$t('invoices.qr_verifactu')" :data="form.URLQR" />
            </div>

            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div class="px-2 w-full mb-2 lg:mb-0">
                <div class="flex-col">
                  <base-button class="mt-1" @click.prevent="openUrlVerifactu" :text="$t('invoices.consultar_aeat')"></base-button>
                </div>
              </div>
              <div v-if="hasFacturae" class="px-2 w-full mb-2 lg:mb-0">
                <div class="flex-col">
                  <base-button class="mt-1" @click.prevent="goInvoice" :text="$t('verifactu.related_facturae')"></base-button>
                </div>
              </div>
            </div>

            <div v-if="form.ErrorVerifactu.CodigoError" class="my-8 lg:mb-4">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-2">{{ $t('verifactu.error_verifactu') }}</h3>
              <el-table :data="[form.ErrorVerifactu]" style="width: 100%">
                <el-table-column prop="MensajeError" :label="$t('verifactu.message_error')" width="full">
                </el-table-column>
                <el-table-column prop="CodigoError" :label="$t('verifactu.error_code')" width="90" >
                </el-table-column>
              </el-table>
            </div>

            <div class="mt-8 lg:mb-4">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-2">{{ $t('invoices.invoices_documents') }}</h3>
              <el-table ref="documentos" :data="form.Documentos" style="width: 100%" :empty-text="$t('app.no_data_text')"
                :show-header="form.Documentos && form.Documentos.length > 0">
                <el-table-column prop="tipo" width="36" align="center">
                  <template slot-scope="tipos">
                    <el-tooltip v-if="tipos.row.tipo" placement="left">
                      <div slot="content">
                        <div class="max-w-sm max-h-500p overflow-auto">
                          <div v-if="tipos.row.tipo === 'xml'">{{ $t('invoices.xml_invoice') }}</div>
                          <div v-else>{{ $t('invoices.document_adj_emb_long') }}</div>
                        </div>
                      </div>
                      <base-icon :name="tipos.row.tipo" />
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="Nombre" :label="$tc('app.documents', 1)" min-width="140" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="actions" width="180" align="center" :label="$tc('app.actions', 2)">
                  <template slot-scope="Documentos">
                    <div class="flex flex-row">
                      <base-button-icon v-if="Documentos.row.icon === 'eye' || Documentos.row.icon === 'eyeslash'"
                        class="mr-2" @click="showAdjunto(Documentos.row, true)" :name="Documentos.row.icon" mode="core" />
                      <base-button-icon class="mr-2" @click="downloadAdjunto(Documentos.row, false)" name="download" mode="core" />
                      <base-button-icon v-if="Documentos.row.Extension === 'xml'" class="mr-2"
                        @click="showEmbedXml(Documentos.row, this)" :name="Documentos.row.visible && showXml ? 'embedslash': 'embed' " mode="core"/>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="Extension" :label="$t('app.extension')" width="90">
                </el-table-column>
                <el-table-column prop="actions" width="90" label="" v-if="showDeleteColumn && false">
                  <!-- <template slot-scope="scope">
                    <span @click.stop="download" class="icon-download p-2 cursor-pointer text-primary-900" />
                    <base-button-icon
                      v-if="idEstado === 0 && scope.row.idRelatedDocument !== 0 && scope.row.Relacionado === false && showInvoiceActions"
                      @click="deleteAdjunto(scope.row)" name="trash" mode="core" />
                  </template> -->
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="RightCol">
      <div class="loader" v-if="isGeneralLoading">
        <loading :opacity="0" :active.sync="isGeneralLoading" color="var(--primary-DEFAULT)"></loading>
      </div>
      <div v-if="showXhtml" class="w-full h-full p-2 iframe-xhtml dark:bg-white">
        <iframe id="container-xhtml-iframe" class="w-full p-2 iframe-xhtml" scrolling="auto" ref="frame"></iframe>
      </div>
      <div v-else-if="showXml" class="p-4 pt-6 h-full overflow-auto">
        <span v-show="false" v-html="xmlData"></span>
        <xml-document class="w-full p-2 iframe-xhtml" :xml-string="xmlData"/>
      </div>
      <div v-else-if="showImage" class="place-content-center dark:bg-darkblue-800 relative p-4 w-full h-auto overflow-x-auto lg:h-full divide-y-2 divide-blue-200 dark:divide-gray-800">
        <img :src="srcImage" class="m-auto h-auto rounded-lg border-2 border-primary-400 shadow-xl">
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack"
            :loading="isGeneralLoading" />
        </template>
      </base-footer>
    </template>
  </detail-layout-two-columns>
</template>

<script>
import moment from 'moment'
import { i18n } from '@/i18n'

import Loading from 'vue-loading-overlay'
import DetailLayoutTwoColumns from '@/components/layout/DetailLayoutTwoColumns.vue'
import BaseButtonIcon from '@/components/base/BaseButtonIcon.vue'
import XMLDocument from '@/components/XMLDocument.vue'

import { getRegistroVerifactuDetail } from '@/services/configurations/getRegistroVerifactuDetail'
import { getDocumentoRegistroVerifactu } from '@/services/configurations/getDocumentoRegistroVerifactu'
import { getDocumentoRegistroVerifactuXml } from '@/services/configurations/getDocumentoRegistroVerifactuXml'
import { getXhtmlVerifactu } from '@/services/configurations/getXhtmlVerifactu'


export default {
  name: 'verifactu',
  components: {
    DetailLayoutTwoColumns,
    BaseButtonIcon,
    'xml-document': XMLDocument,
    Loading
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
        disabledDate: this.disabledDate
      },
      showXml: false,
      showImage: false,
      showXhtml: false,
      iFrameContent: '',
      srcImage: '',
      xmlData: '',
      xmlVersionTagOpen: '<?xml',
      xmlVersionTagClose: '?>',
      header: {
        title: `${i18n.t('app.detail')} ${i18n.t('verifactu.header')}`,
        icon: 'docblack',
        breadcrumb: {},
        nav: [],
        url: '/verifactu'
      },
      form: {
        NumSerieAnterior: '',
        FechaExpedicionAnterior: '',
        IdFacturaeFacturaRelacionado: null,
        IdInvoiceFacturaRelacionado: null,
        IdEstadoFacturaRelacionado: null,
        ErrorVerifactu: {},
        Documentos: [],
        Cliente: '',
        Distribuidor: '',
        Empresa: '',
        CIF: '',
        URLQR: '',
        SIF: '', 
        IdEstadoVerifactu: '',
        IdAccionVerifactu: '',
        IdTipoFactura: '',
        CuotaTotal: '',
        ImporteTotal: '',
        HuellaRegistro: '',
        FechaAlta: '',
        FechaNotificacion: '',
        CSVZC: '',
        CSVAEAT: '',
        IdCifEmpresa: '',
        NumSerieFactura: '',
        FechaExpedicion: '',
      },
      rules: {},
      url: '',
      invoiceActions: [],
    }
  },
  watch: {},
  computed: {
    hasFacturae: function () {
      return this.form.IdFacturaeFacturaRelacionado !== null
    },
    tiposFactura: function () {
      return this.$store.getters['config/TIPOS_FACTURA']
    },
    tiposAccionVerifactu: function () {
      return this.$store.getters['config/TIPOS_OPERACION']
    },
    tiposEstadoVerifactu: function () {
      return this.$store.getters['config/TIPOS_ESTADO_VERIFACTU']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    // hasVerifactuModule () {
    //   return !!this.$store.getters['auth/hasVerifactuModule']
    // },
    idCliente: function () {
      return parseInt(this.$route.params.IdCliente)
    },
    idCifEmpresa: function () {
      return parseInt(this.$route.params.IdCifEmpresa)
    },
    numSerieFactura: function () {
      return this.$route.params.NumSerieFactura
    },
    fechaExpedicion: function () {
      return this.$route.params.FechaExpedicion.split('T')[0]
    },
    CSVZC: function () {
      return this.$route.params.CSVZC
    },
    idEstado: function () {
      return parseInt(this.$route.params.type)
    },
    fromGeneral: function () {
      return this.$route.params.fromGeneral
    },
    routeBack: function () {
      if (!this.fromGeneral) return `/verifactu/${this.idEstado}`
      return 'verifactu'
    },
    hasVerifactuInformation () {
      return !!this.form.urlVerifactu
    },
    showDeleteColumn: function () {
      return this.idEstado === 0 && this.form.Adjuntos.some(x => x.idRelatedDocument !== 0 && x.Relacionado === false) && this.showInvoiceActions
    },
  },
  created: async function () {
    const params = {
      idCliente: this.idCliente,
      idCifEmpresa: this.idCifEmpresa,
      NumSerieFactura: this.numSerieFactura,
      fechaExpedicion: this.fechaExpedicion,
      CSVZCHistorico: this.CSVZC,
    }
    await this.downloadVerifactuData(params)

    this.header.url = this.routeBack

    const breadcrumbs = []
    const asuntoBreadCrumb = this.form.NumSerieFactura

    breadcrumbs.push({ path: 'verifactu', name: i18n.t('verifactu.header') })
    breadcrumbs.push({ path: `verifactu/${this.idEstado}`, name: this.form.IdEstadoVerifactu })
    breadcrumbs.push({ path: '', name: this.truncate(asuntoBreadCrumb, 30, false) })

    this.$store.commit('app/setheaderBreadCrumb', asuntoBreadCrumb)
    this.$store.commit('app/setstateBreadCrumb', { id: this.idEstado, Nombre: this.form.IdEstadoVerifactu })
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    disabledDate: function (date) {
      const dateMoment = moment(date)
      return !dateMoment.isBetween(moment(this.form.fechaFactura), moment(), 'day', '[]')
    },
    goBack: function () {
      this.$router.push({ name: this.header.url })
    },
    downloadVerifactuData: async function (params) {
      try {
        const verifactu = await getRegistroVerifactuDetail(params)
        if (verifactu.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', verifactu))
        }
        this.setVerifactu(verifactu.respuesta)
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    setVerifactu: function (verifactu) {
      this.form.NumSerieAnterior = verifactu.NumSerieFacturaAnterior
      this.form.IdFacturaeFacturaRelacionado = verifactu.IdFacturaeFacturaRelacionado
      this.form.IdInvoiceFacturaRelacionado = verifactu.IdInvoiceFacturaRelacionado
      this.form.IdEstadoFacturaRelacionado = verifactu.IdEstadoFacturaRelacionado

      this.form.FechaAlta = i18n.d(verifactu.FechaAlta, 'numeric_date', { date: '-' })
      this.form.FechaNotificacion = i18n.d(verifactu.FechaNotificacion, 'numeric_date', { date: '-' })
      this.form.FechaExpedicion = i18n.d(verifactu.FechaExpedicion, 'numeric_date', { date: '-' })
      this.form.FechaExpedicionAnterior = i18n.d(verifactu.FechaExpedicionAnterior, 'numeric_date', { date: '-' })

      this.form.Cliente = verifactu.Cliente
      this.form.Distribuidor = verifactu.Distribuidor
      this.form.Empresa = verifactu.Empresa
      this.form.CIF = verifactu.CIF
      this.form.URLQR = verifactu.URLQR
      this.form.SIF = verifactu.SIF

      this.form.IdEstadoVerifactu = this.tiposEstadoVerifactu.find(x => x.id === verifactu.IdEstadoVerifactu)?.Nombre ?? verifactu.IdEstadoVerifactu
      this.form.IdAccionVerifactu = this.tiposAccionVerifactu.find(x => x.id === verifactu.IdAccionVerifactu)?.Nombre ?? verifactu.IdAccionVerifactu
      this.form.IdTipoFactura = this.tiposFactura.find(x => x.id === verifactu.IdTipoFactura)?.name ?? verifactu.IdTipoFactura

      this.form.CuotaTotal = verifactu.CuotaTotal.toString()
      this.form.ImporteTotal = verifactu.ImporteTotal.toString()
      this.form.HuellaRegistro = verifactu.HuellaRegistro
      this.form.CSVZC = verifactu.CSVZC
      this.form.CSVAEAT = verifactu.CSVAEAT
      this.form.IdCifEmpresa = verifactu.IdCifEmpresa
      this.form.NumSerieFactura = verifactu.NumSerieFactura

      this.form.Documentos = [...verifactu.Documentos]
      this.form.Documentos.forEach(x => {
        this.$set(x, 'icon', 'eye')
        this.$set(x, 'visible', false) 
        const file = x.Nombre.split('.')
        x.Extension = file[1]
        x.Nombre = file[0]
      })

      if (this.form.Documentos[0]) {
        this.showAdjunto(this.form.Documentos[0])
      }

      if (verifactu.ErrorVerifactu) {
        this.form.ErrorVerifactu = {
          CodigoError: verifactu.ErrorVerifactu.CodigoError || null,
          MensajeError: verifactu.ErrorVerifactu.MensajeError || null,
        }
      }
    },
    resetDocumentsSelected: async function (rowException = null) {
      if (this.form.Documentos) {
        this.form.Documentos.forEach(key => {
          // Resetea si no es el actual
          if (!rowException || !(rowException.idRelatedDocument === key.IdFicheroVerifactu)) {
            this.resetRowName(key)
            key.visible = false
            key.icon = key.Extension.trim() === 'xml' || key.Extension.trim() === 'XML' || key.Extension.trim() === 'png'|| key.Extension.trim() === 'PNG' ? 'eye' : 'download'
          }
        })
      }
    },
    showAdjunto: async function (row) {
      const params = {
        idCliente: this.idCliente, 
        idCifEmpresa: this.idCifEmpresa,
        numSerieFactura: this.form.NumSerieFactura,
        fechaExp: this.$route.params.FechaExpedicion,
        CSVZC: this.form.CSVZC,
      }
      const exceptionDocument = {
        docRel: false,
        idRelatedDocument: row.IdFicheroVerifactu,
      }
      await this.resetDocumentsSelected(exceptionDocument)
      if (row.IdFicheroVerifactu === 1 && row.Extension.trim().toUpperCase() === 'XML') {
        this.showImage = false
        this.showXml = false
        this.showXhtml = true 
        if (row.icon === 'eye') {
          row.visible = true
          row.icon = 'eyeslash'
          const response = await getXhtmlVerifactu(params)
          if (response.blnError) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.iFrameContent = response.Respuesta
            this.insertIframeContent()
          }
        } else {
          row.icon = 'eye'
          this.showXml = false
        }
        this.resetRowName(row)
      } else if (row.Extension.trim().toUpperCase() === 'PNG') {
        params.idAdjunto = parseInt(row.IdFicheroVerifactu)
        const blob = await this.getBlob(params)
        this.showXml = false
        this.showXhtml = false
        if (blob !== undefined) {
          await this.showImageVisor(blob)
          if (row.icon === 'eye') {
            row.icon = 'eyeslash'
            this.showImage = true
          } else {
            row.icon = 'eye'
            this.showImage = false
          }
          this.resetRowName(row)
        }
      }
    },
    showEmbedXml: async function (row, action) {
      const params = {
        idCliente: this.idCliente, 
        idCifEmpresa: this.idCifEmpresa,
        numSerieFactura: this.form.NumSerieFactura,
        fechaExp: this.$route.params.FechaExpedicion,
        CSVZC: this.form.CSVZC,
        idAdjunto: parseInt(row.IdFicheroVerifactu),
      }
      const exceptionDocument = {
        docRel: false,
        idRelatedDocument: row.IdFicheroVerifactu,
      }
      await this.resetDocumentsSelected(exceptionDocument)
      if (!this.showXml || !row.visible) {
        if (row.Extension.trim().toUpperCase() === 'XML') {
          if (row.IdFicheroVerifactu === 1) {
            row.icon = 'eye'
            this.resetRowName(row)
          }
          this.showImage = false
          this.showXhtml = false
          const xmlString = await this.getXml(params)
          if (typeof xmlString === 'string') {
            row.visible = true
            this.showXml = true 
            await this.showTextEditorXml(xmlString)
          }
          this.resetRowName(row)
        }
      } else {
        this.showXml = false
        row.visible = false
      }
    },
    showTextEditorXml: async function (xmlString) {
      this.$store.commit('setIsLoading', true)
      this.showXml = true
      this.showImage = false  

      this.xmlData = this.escapeUsingDOM(xmlString).replaceAll('&lt;', '<').replaceAll('&gt;', '>')

      this.$store.commit('setIsLoading', false)
    },
    showImageVisor: async function (blob) {
      this.$store.commit('app/setLoading', true)
      this.showXml = false
      this.showImage = true
      this.srcImage = window.URL.createObjectURL(blob)
    },
    escapeUsingDOM: function (str) {
      const div = document.createElement('div')
      div.textContent = str
      return div.innerHTML
    },
    resetRowName (row) {
      // Tmp update icon
      const auxNombre = row?.Nombre || row
      row.Nombre = auxNombre + ' '
      setTimeout(() => {
        row.Nombre = auxNombre
      }, 50)
    },
    downloadAdjunto: async function (row, docRel = false) {
      try {
        this.$store.commit('app/setLoading', false)
        const params = {
          idCliente: this.idCliente, 
          idCifEmpresa: this.idCifEmpresa,
          numSerieFactura: this.form.NumSerieFactura,
          fechaExp: this.$route.params.FechaExpedicion,
          CSVZC: this.form.CSVZC,
          idAdjunto: parseInt(row.IdFicheroVerifactu),
        }
        const blob = await this.getBlob(params)
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = row.Nombre.trim() + '.' + row.Extension.trim()
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        this.doFeedback(error)
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    getBlob: async function (params) {
      try {
        this.$store.commit('app/setLoading', true)
        const response = await getDocumentoRegistroVerifactu(params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        return blob
      } catch (error) {
        this.doFeedback(error)
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    getXml: async function (params) {
      try {
        this.$store.commit('app/setLoading', true)
        const response = await getDocumentoRegistroVerifactuXml(params)
        return response.data
      } catch (error) {
        this.doFeedback(error)
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    insertIframeContent () {
      let iframe = document.getElementById('container-xhtml-iframe')

      if (iframe) {
        iframe.addEventListener('load', () => {
          const doc = iframe?.contentDocument || iframe?.document || iframe
          const style = doc.createElement('style')
          style.textContent= this.getScrollBarsStyle()
          style.textContent += '.page { padding: 15mm; } @media not print { html { max-height: 100%; } body { width: 210mm; height: 297mm; overflow-x: hidden; } body { transform-origin: top left; transform: scale(calc(100vw / 210mm)); } }'
          doc.head.appendChild(style)
        })
        iframe = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument)
  
        iframe.document.open()
        iframe.document.write(this.iFrameContent)
        iframe.document.close()
      }
    },
    getScrollBarsStyle: function () {
      const computedStyle = getComputedStyle(document.documentElement)
      const variableNames = ['--primary-400', '--primary-500', '--Component-background-']
      const rootStyle = variableNames.map(x => `${x}: ${computedStyle.getPropertyValue(x)}`).join('; ')
      return `:root { ${rootStyle} } ::-webkit-scrollbar { width: 8px; height: 8px; } ::-webkit-scrollbar-thumb { background-color: var(--primary-400); border-radius: 20px; } ::-webkit-scrollbar-corner { background: var(--Component-background-); } ::-webkit-scrollbar-thumb:hover { background: var(--primary-500); } ::-webkit-scrollbar-button { height: 2px; width: 2px; }`
    },
    truncate: function (str, n, useWordBoundary) {
      if (str.length <= n) { return str }
      const subString = str.substr(0, n - 1) // the original check
      return (useWordBoundary
        ? subString.substr(0, subString.lastIndexOf(' '))
        : subString) + '...'
    },
    openUrlVerifactu: function () {
      window.open(this.form.URLQR, '_blank')
    },
    goInvoice: function () {
      this.$router.push({ 
        name: 'invoicesissued/details',
        params: { 
          type: parseInt(this.form.IdEstadoFacturaRelacionado), 
          idFacturae: parseInt(this.form.IdFacturaeFacturaRelacionado), 
          idInvoice: parseInt(this.form.IdInvoiceFacturaRelacionado)
        } 
      })
    }
  }

}
</script>

<style scoped>

.normalizeHeader {
  padding-left: 0px;
  padding-right: 0px;
}

::v-deep .right-col{
  overflow-y: auto !important;
}

.dark img{
  box-shadow: 0px 35px 55px 0px rgba(0, 0, 0, 1);
}

.full-screen-pdf {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}

.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}

.grid {
  display: grid;
  grid-gap: 10px;
}

.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}

.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}

.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}

.tip {
  grid-column: 1 / -1;
}

.pic>img {
  max-width: 100%;
  max-height: 100%;
}

@media (min-width: 1024px) {
  ::v-deep .right-col {
    height: var(--left-height);
    overflow: hidden;
  }
}
</style>

<style lang="scss" >
.hideHeader {
  display: none
}

.showHeader {
  display: block
}

.hideHScroll {
  overflow-x: hidden;
}

.iframe-xhtml {
  width: 100%;
  height: 100%;
}

.min-input-height {
    padding: .25rem 0 0.70rem 0;
  }
</style>
